import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { CircularProgress, Box } from '@mui/material';
import { canAccessPlatform } from '../../utils/permissions';
import { getRoleHomePath } from '../../config/roles';
import { isWorkdayGatedRole } from '../../workday/constants';

/**
 * PublicRoute — unauthenticated pages; authenticated users go to workday gate or home.
 */
const PublicRoute = ({ children }) => {
    const { isAuthenticated, loading, user } = useAuth();

    if (loading) {
        return (
            <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                minHeight="100vh"
                backgroundColor="#D2EFE6"
            >
                <CircularProgress sx={{ color: '#3A8667' }} />
            </Box>
        );
    }

    if (isAuthenticated && user) {
        if (canAccessPlatform(user.role)) {
            return <Navigate to="/admin/dashboard" replace />;
        }
        if (isWorkdayGatedRole(user.role)) {
            return <Navigate to="/workday/check-in" replace />;
        }
        return <Navigate to={getRoleHomePath(user.role)} replace />;
    }

    return children;
};

export default PublicRoute;
